import { default as Campaign } from './ComponentList';

export { Campaign };



// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsAppProvider/components/index.js